var _style, _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteHsLogo = function SvgWhiteHsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 705.6 116.3",
    style: {
      enableBackground: "new 0 0 705.6 116.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.5,3.3c4.8,2.1,8.5,5.1,11.3,9c2.8,3.9,4.3,8.4,4.6,13.5h-21.9c-0.5-2.9-1.6-5.1-3.5-6.7c-1.8-1.5-4.2-2.3-7.3-2.3 c-4.5,0-8.1,2-10.8,5.9c-2.6,4-4,9.3-4,16.1c0,6.9,1.3,12.5,4,16.5c2.6,4.1,6.3,6.1,10.9,6.1c3.9,0,7-1.2,9.3-3.6 c2.3-2.4,3.6-5.6,3.8-9.6h-14.1V33.1h33.3v42.1h-17.6v-7h-0.2c-2.2,2.8-5,5-8.3,6.4c-3.3,1.4-7.1,2.2-11.4,2.2 c-6.4,0-12-1.5-16.7-4.6c-4.7-3.1-8.3-7.4-10.8-13.2c-2.5-5.7-3.8-12.4-3.8-20.2c0-8,1.5-14.9,4.4-20.7 c2.9-5.8,7.1-10.3,12.6-13.4c5.5-3.1,12-4.6,19.5-4.6C153.2,0.1,158.7,1.2,163.5,3.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 1.8,
    width: 20.6,
    height: 73.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.7,1.8 44.7,28.8 20.6,28.8 20.6,1.8 0,1.8 0,75.2 20.6,75.2 20.6,46.1 44.7,46.1 44.7,75.2 65.3,75.2  65.3,1.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.3,75.2 237.3,46.1 213.3,46.1 213.3,75.2 192.7,75.2 192.7,1.8 213.3,1.8 213.3,28.8 237.3,28.8 237.3,1.8  258,1.8 258,75.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,6.1c5.2,4.1,7.8,10,7.8,17.8H324c0-2.7-0.8-4.7-2.3-6.2c-1.5-1.4-3.8-2.2-6.8-2.2c-2.5,0-4.5,0.5-6,1.5 c-1.4,1-2.2,2.4-2.2,4.1c0,1.4,0.4,2.5,1.2,3.4c0.8,0.9,2.1,1.6,3.9,2.2c1.8,0.6,4.5,1.4,8.2,2.3c5.8,1.4,10.6,3,14.4,4.6 c3.7,1.6,6.8,4,9.2,7.1c2.4,3.1,3.6,7.2,3.6,12.3c0,4.9-1.3,9.1-3.8,12.6c-2.5,3.5-6.1,6.3-10.8,8.2c-4.7,1.9-10.3,2.9-16.7,2.9 c-10,0-17.7-2.2-23.3-6.7c-5.6-4.5-8.4-10.7-8.4-18.8h22.3c0,6.3,3.4,9.4,10.1,9.4c2.8,0,4.9-0.6,6.4-1.7c1.5-1.1,2.3-2.7,2.3-4.6 c0-1.5-0.4-2.7-1.2-3.6c-0.8-0.9-2.1-1.6-3.7-2.2s-4.3-1.4-7.9-2.3c-6.1-1.7-10.9-3.2-14.4-4.7c-3.6-1.5-6.5-3.7-8.9-6.7 c-2.3-3-3.5-6.9-3.5-11.9c0-4.6,1.2-8.7,3.6-12.1c2.4-3.5,5.9-6.2,10.4-8.1C304.3,0.9,309.7,0,316,0C325.4,0,332.7,2,337.9,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,68.8c-5.4,5.3-13.1,8-23.1,8c-10,0-17.7-2.6-23.1-7.9c-5.4-5.3-8.2-12.9-8.2-22.7V1.7h20.6v44.2 c0,4.2,0.9,7.4,2.7,9.6c1.8,2.2,4.5,3.4,7.9,3.4c3.4,0,6.1-1.1,7.8-3.4c1.8-2.2,2.7-5.5,2.7-9.6V1.7h20.6v44.5 C419.3,55.9,416.6,63.4,411.2,68.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5,35.7h7.5c7.2,0,10.8-3,10.8-9c0-5.9-3.6-8.9-10.8-8.9h-7.5V35.7z M485.8,8.3c4.9,4.4,7.4,10.6,7.4,18.4 c0,7.8-2.5,14-7.4,18.5c-4.9,4.5-12.2,6.7-21.8,6.7h-10.4v23.2h-20.6V1.7h31.1C473.6,1.7,480.8,3.9,485.8,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,35.7h7.5c7.2,0,10.8-3,10.8-9c0-5.9-3.6-8.9-10.8-8.9H523V35.7z M555.2,8.3c4.9,4.4,7.4,10.6,7.4,18.4 c0,7.8-2.5,14-7.4,18.5c-4.9,4.5-12.2,6.7-21.8,6.7H523v23.2h-20.6V1.7h31.1C543,1.7,550.3,3.9,555.2,8.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.3,57.8 624.3,75.1 571.8,75.1 571.8,1.7 592.4,1.7 592.4,57.8  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.3,75.1h-20.6V48.3L610.5,1.7h22.7l5.8,12.9c2.9,6.5,5.2,12.5,6.9,18.2h0.2c1.9-5.8,4.2-11.9,7-18.2l5.8-12.9h22.6 l-25.2,46.6V75.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "685.3,1.6 694,1.6 694,4.1 691.1,4.1 691.1,11.7 688.1,11.7 688.1,4.1 685.3,4.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "701.7,1.6 700.2,7.3 700.2,7.3 698.6,1.6 694.8,1.6 694.8,11.7 697.4,11.7 697.4,5.4 697.4,5.4 699.1,11.7  701.2,11.7 702.9,5.4 702.9,5.4 702.9,11.7 705.6,11.7 705.6,1.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 678.2,
    height: 20.2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteHsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-hs-logo.40f222a4.svg";
export { ForwardRef as ReactComponent };